export const makeArchiveUrl = (projectUuid: string, archiveId: number) => {
  return `/dashboard/project.archive/${projectUuid}/${archiveId}`;
};

export const makeUserProfilesUrl = (userUuid: string) => {
  return `/dashboard/member/${userUuid}`;
};
